import i18n from '../../lang/index'
const billingRouter = [{
  path: '/billing',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'billinglist'
  },
  children: [{
      name: 'billinglist',
      path: 'index',
      meta: {
        tab: '',
        title:i18n.t('user.billingTitle'),
      },
      component: () => import('@/pages/billing/Billing'),
    },

  ]
}]
export default billingRouter



// WEBPACK FOOTER //
// ./src/router/modules/billing.js